import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteBlog, fetchBlogs } from "../../slices/blogSlice";
import ModalBlog from "../../Components/addModalForBlog";
import BlogDetail from "../../Components/blogDetailAdmin";
import Success from "../../Components/success";

const ManageBlog = () => {
  const [detailOpen, setDetailOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [selectedBlog, setBlog] = useState(null);
  const dispatch = useDispatch();
  const { blogs, status, error } = useSelector((state) => state.blogs);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);

  const openDetail = (blog) => {
    setBlog(blog);
    setDetailOpen(true);
  };

  const remove = (blogId) => {
    setDetailOpen(false);
    dispatch(deleteBlog(blogId));
    dispatch(fetchBlogs());
    if (status === "succeeded") {
      setIsSuccess(true);
    }
  };

  return (
    <section className="manageblog-section">
      <div className="top">
        <ul className="operation">
          <li>
            <a href="#" onClick={() => setIsModalOpen(true)}>
              Yeni blog yarat
            </a>
          </li>
        </ul>
      </div>
      <table className="tab-blogs">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>TitleDesc</th>
            <th>Description</th>
            <th>Əməliyyatlar</th>
          </tr>
        </thead>
        <tbody>
          {blogs.map((blog) => (
            <tr>
              <td className="id-tr" onClick={() => openDetail(blog)}>
                {blog.id}
              </td>
              <td>{blog.title}</td>
              <td>
                {blog.titleDesc.length > 10
                  ? blog.titleDesc.substring(0, 10) + "..."
                  : blog.titleDesc}
              </td>
              <td>
                {blog.description.length > 10
                  ? blog.description.substring(0, 10) + "..."
                  : blog.description}
              </td>
              <td>
                <button
                  onClick={() => remove(blog.id)}
                  className="operation-button"
                >
                  Blogu sil
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {isModalOpen && (
        <ModalBlog isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      )}

      {detailOpen && (
        <BlogDetail
          isOpen={detailOpen}
          onClose={() => setDetailOpen(false)}
          blog={selectedBlog}
        />
      )}

      {isSuccess && (
        <Success isOpen={isSuccess} onClose={() => setIsSuccess(false)} />
      )}
    </section>
  );
};

export default ManageBlog;
